// extracted by mini-css-extract-plugin
export var textInput = "_l9-0";